import eventDetail from './eventDetail';

export default {
  eventDetail,
};
